import { createContext } from 'react';
import { CorpUIResponse } from 'src/types/Corp';
import { Employee } from 'src/types/Employee';

export interface EmployeeFormContextType {
  isEditPage: boolean;
  corpData: CorpUIResponse;
  corpId?: string;
  employeeId?: string;
  employeeData?: Employee;
  isInternalAdminUser: boolean;
  isOnlyCorpAdminUser: boolean;
}

export const EmployeeFormContext =
  createContext<EmployeeFormContextType | null>(null);
